import {
  SlPopup
} from "./chunk.5JY5FUCG.js";

// src/components/popup/popup.ts
var popup_default = SlPopup;
SlPopup.define("sl-popup");

export {
  popup_default
};
